import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaShoppingCart,
  FaHome,
  FaRupeeSign,
  FaClipboardList,
} from "react-icons/fa";
import { motion } from "framer-motion";

export default function BuyRentSell() {
  const nav = useNavigate();
  const actions = [
    {
      label: "Browse Listings",
      path: "/market/listings",
      Icon: FaShoppingCart,
      color: "success",
      tagline: "See items available for rent or sale",
    },
    {
      label: "Find Rooms",
      path: "/rooms",
      Icon: FaHome,
      color: "info",
      tagline: "Discover rooms near your location",
    },
    {
      label: "Post an Item",
      path: "/market/post",
      Icon: FaRupeeSign,
      color: "warning",
      tagline: "List your product in minutes",
    },
    {
      label: "Manage Requests",
      path: "/market/purchases",
      Icon: FaClipboardList,
      color: "primary",
      tagline: "Review purchase inquiries from buyers",
    },
  ];

  return (
    <Container
      fluid
      className="py-5 px-0"
      style={{
        background: "linear-gradient(120deg, #e0e7ff 0%, #f8fafc 100%)",
      }}
    >
      <h2 className="mb-2 text-center fw-bold text-gradient">Marketplace</h2>
      <p className="text-center text-secondary mb-5 fs-5">
        Buy, rent, or sell properties with ease and security.
      </p>
      <Row xs={1} md={3} className="g-4 justify-content-center">
        {actions.map((a, i) => (
          <Col key={a.label}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.2 + i * 0.15,
                duration: 0.5,
                type: "spring",
              }}
              whileHover={{
                scale: 1.06,
                boxShadow: "0 12px 32px 0 rgba(37,99,235,0.13)",
              }}
            >
              <Card
                className="h-100 text-center shadow-hover border-0"
                style={{
                  cursor: "pointer",
                  borderTop: `4px solid var(--bs-${a.color})`,
                }}
                onClick={() => nav(a.path)}
              >
                <Card.Body>
                  <a.Icon size={48} className={`text-${a.color}`} />
                  <Card.Title className="mt-3 fw-bold fs-3">
                    {a.label}
                  </Card.Title>
                  <Card.Text className="mb-3 text-secondary">
                    {a.tagline}
                  </Card.Text>
                  <Button
                    variant={a.color}
                    className="px-4 py-2 shadow-hover"
                    onClick={() => nav(a.path)}
                  >
                    {a.label}
                  </Button>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
